export const SUPPORTED_LANGUAGES = ['de', 'en', 'fr', 'it'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export type SpaceKey = 'general' | 'development' | 'operations'

export type SpaceInfo = {
  key: SpaceKey
  label: string
  labels: Record<string, string>
}
